import React from 'react';
import { Dialog, DialogTitle, DialogContent, IconButton, Typography, Box, Alert } from '@mui/material';
import { Close } from '@mui/icons-material';
import { PasswordResetForm } from './PasswordResetForm';
import { useAuth } from '../contexts/AuthContext';

const PasswordRecoveryModal: React.FC = () => {
  const { showPasswordRecoveryForm, setShowPasswordRecoveryForm, cancelPasswordRecovery } = useAuth();

  const handleSuccess = () => {
    setShowPasswordRecoveryForm(false);
  };

  const handleCancel = async () => {
    // Cancel recovery and log out (security measure)
    await cancelPasswordRecovery();
  };

  return (
    <Dialog
      open={showPasswordRecoveryForm}
      onClose={() => {}} // Disable closing by clicking outside or pressing Escape
      aria-labelledby="password-recovery-dialog-title"
      maxWidth="sm"
      fullWidth
      disableEscapeKeyDown // Prevent closing with Escape key
      disableRestoreFocus={true}
      PaperProps={{
        sx: {
          borderRadius: 2,
          boxShadow: '0 10px 40px rgba(0,0,0,0.1)',
        }
      }}
    >
      <DialogTitle sx={{ m: 0, p: 2, display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
          <Typography variant="h6" sx={{ fontSize: '2rem' }}>🔐</Typography>
          <Typography variant="h6" component="div" sx={{ color: 'primary.main', fontWeight: 600 }}>
            Set New Password
          </Typography>
        </Box>
        <IconButton
          aria-label="close"
          onClick={handleCancel}
          sx={{ color: 'grey.500' }}
        >
          <Close />
        </IconButton>
      </DialogTitle>
      <DialogContent sx={{ p: 3 }}>
        <Alert severity="info" sx={{ mb: 3 }}>
          For security reasons, you must set a new password to complete the password recovery process. 
          If you cancel, you will be logged out.
        </Alert>
        <Typography variant="body2" sx={{ mb: 3, color: 'text.secondary' }}>
          Please enter your new password to complete the reset process.
        </Typography>
        <PasswordResetForm 
          onSuccess={handleSuccess}
          onCancel={handleCancel}
        />
      </DialogContent>
    </Dialog>
  );
};

export default PasswordRecoveryModal;
